import { mutatorAction } from 'satcheljs';
import { getActivityFeedStore } from '../store/store';
import { ActivityFeedStorageItem, ActivityType } from '../service/ActivityFeedStorageItem';
import { isFeatureEnabled } from 'owa-feature-flags';

export const activityFeedLoaded = mutatorAction(
    'ACTIVITY_FEED_LOADED',
    (items: ActivityFeedStorageItem[]) => {
        const store = getActivityFeedStore();
        store.firstFetchComplete = true;
        if (items) {
            // an ObservableMap preserves insertion order, hence clearing to ensure
            // we reflect the order the API payload has.
            store.items.clear();

            const predicate = (item: ActivityFeedStorageItem): boolean => {
                return supportedActivity(
                    item,
                    isFeatureEnabled('auth-activityFeedRenderUserAtMentioned'),
                    isFeatureEnabled('auth-activityFeedRenderTxpFlight'),
                    isFeatureEnabled('auth-activityFeedRenderParcelDelivery'),
                    isFeatureEnabled('auth-activityFeedRenderMyAnalytics')
                );
            };
            items.filter(predicate).forEach(item => {
                store.items.set(item.id, {
                    /*
                        Typescript won't let us assign the broad ActivityType and any payload to the
                        union of the specific type/payload pairs. To get rid of this type assertion,
                        we would need to check that the server has correctly paired the item type and payload
                       */
                    type: item.type as any,
                    payload: JSON.parse(item.activityFeedItemPayload),
                    id: item.id,
                    version: item.version,
                    expiry: item.expiry,
                    isSeen: item.isSeen,
                    isRead: item.isRead,
                    isDismissed: item.isDismissed,
                    priority: item.priority,
                    timeOfAction: item.timeOfAction,
                    aggregationKey: item.aggregationKey,
                    timestamp: item.timestamp,
                });
            });
        } else {
            // action was called with no items indicating no items so clear the store
            store.items.clear();
        }
    }
);

function supportedActivity(
    item: ActivityFeedStorageItem,
    userAtMentionSupport: boolean,
    flightTxpSupport: boolean,
    parcelDeliverySupport: boolean,
    myAnalyticsSupport: boolean
): boolean {
    if (item.type == undefined || item.type == null) {
        return false;
    }

    switch (item.type) {
        case ActivityType.Like:
        case ActivityType.AtMention:
            return true;
        case ActivityType.TxpFlightReservation:
            return flightTxpSupport;
        case ActivityType.TxpParcelDelivery:
            return parcelDeliverySupport;
        case ActivityType.UserAtMentioned:
            return userAtMentionSupport;
        case ActivityType.TaskNotificationInsight:
            return myAnalyticsSupport;
        default:
            return false;
    }
}
